<template>
  <basic-container>
     <el-tabs v-model="activeName" type="card" @tab-click="tableData=[];searchAct()">
      <el-tab-pane label="线上数据" name="1"></el-tab-pane>
      <el-tab-pane label="本地数据" name="0"></el-tab-pane>
    </el-tabs>
    <div class="search_group">
      <el-select @change="searchAct" v-model="productId" filterable clearable size="small" placeholder="选择商品名称">
        <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-select @change="searchAct" v-model="isIOS" size="small" clearable placeholder="销售渠道">
        <el-option label="非IOS内购" :value="0"></el-option>
        <el-option label="IOS内购" :value="1"></el-option>
      </el-select>
      <el-select @change="searchAct" v-model="discountStatus" size="small" clearable placeholder="优惠状态">
        <el-option label="生效" :value="1"></el-option>
        <el-option label="失效" :value="2"></el-option>
      </el-select>
      <el-select v-if="activeName=='0'" @change="searchAct" v-model="checkStatus" size="small" clearable placeholder="审核状态">
        <el-option label="草稿" :value="0"></el-option>
        <el-option label="待审核" :value="1"></el-option>
        <el-option label="通过" :value="2"></el-option>
        <el-option label="不通过" :value="3"></el-option>
      </el-select>
      <el-button @click="searchAct" icon="el-icon-search" size="small" type="primary">搜索</el-button>
      <el-button v-if="activeName=='0'" @click="openEdit" v-auth="'memberDiscount_add'" icon="el-icon-plus" size="small" type="primary">新增</el-button>
    </div>
    <el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :max-height="tableHeight"
      :key="activeName" v-loading="listLoading" element-loading-text="加载中" border :data="tableData">
      <el-table-column fixed label="ID" width="200">
        <template slot-scope="scope">{{activeName=='0'?scope.row.originalId:scope.row.id}}</template>
      </el-table-column>
      <el-table-column prop="productName" label="商品名称" width="200"></el-table-column>
      <el-table-column prop="name" label="优惠标签"></el-table-column>
      <el-table-column prop="originalPrice" label="原价（元）" width="100"></el-table-column>
      <el-table-column label="销售渠道" width="120">
        <template slot-scope="scope">
          {{scope.row.isIOS==1?'IOS内购':scope.row.isIOS==0?'非IOS内购 ':''}}
        </template>
      </el-table-column>
      <el-table-column prop="price" label="优惠价（元）" width="110"></el-table-column>
      <el-table-column label="优惠状态">
        <template slot-scope="scope">{{scope.row.status==1?'生效':scope.row.status==2?'失效':''}}</template>
      </el-table-column>
      <el-table-column v-if="activeName=='0'" label="审核状态">
        <template slot-scope="scope">{{scope.row.reviewStatus | reviewStatus}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="remark" label="备注"></el-table-column>
      <el-table-column v-if="activeName=='0'" fixed="right" width="250" label="操作">
        <template slot-scope="scope">
          <el-button @click="submitCheck(scope.row)" v-if="scope.row.reviewStatus==0||scope.row.reviewStatus==4" v-auth="'memberDiscount_submitCheck'"  icon="el-icon-info" size="mini" type="text">提交审核</el-button>
          <el-button @click="openCheck(scope.row)" v-if="scope.row.reviewStatus==1" v-auth="'memberDiscount_check'" icon="el-icon-info" size="mini" type="text">审核</el-button>
          <el-button @click="changeCheck(scope.row, 4)" v-if="scope.row.reviewStatus==1" v-auth="'memberDiscount_cancelCheck'" icon="el-icon-info" size="mini" type="text">撤销审核</el-button>
          <el-button @click="openLog(scope.row)" v-auth="'memberDiscount_viewLog'" icon="el-icon-view" size="mini" type="text">查看日志</el-button>
          <el-button v-if="activeName=='0'&&scope.row.reviewStatus!=1" @click="openEdit(scope.row)" v-auth="'memberDiscount_change'" icon="el-icon-edit" size="small" type="text">修改</el-button>
          <el-button v-if="activeName=='0'" @click="delDiscount(scope.row)" v-auth="'memberDiscount_delete'" icon="el-icon-delete" size="small" type="text">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table_pagination">
      <el-pagination class="app-pagination" background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="pageSizeArr" :page-size="pageSize" :layout="paginationLayout" :total="totalEl">
      </el-pagination>
    </div>
    <el-dialog title="审核活动" :visible.sync="showCheck" append-to-body width="40%">
      <el-form :model="checkItem" size="mini" label-width="110px">
        <el-form-item label="商品名称">{{checkItem.productName}}</el-form-item>
        <el-form-item label="原价">{{checkItem.originalPrice}}元</el-form-item>
        <el-form-item label="优惠价">{{checkItem.price}}元</el-form-item>
        <el-form-item label="优惠状态">{{checkItem.status==1?'生效':checkItem.status==2?'失效':''}}</el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="checkMark" placeholder="请输入审核意见"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeCheck(checkItem, 2)" v-auth="'memberDiscount_check'" size="small" type="primary" icon="el-icon-circle-check">通过审核</el-button>
        <el-button @click="changeCheck(checkItem, 3)" v-auth="'memberDiscount_check'" size="small" type="danger" icon="el-icon-circle-close">拒绝审核</el-button>
        <el-button @click="showCheck=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="操作日志" :visible.sync="showLog" append-to-body width="40%">
      <el-table :max-height="400" border :data="logData">
        <el-table-column prop="applyUserName" label="申请人"></el-table-column>
        <el-table-column prop="applyTime" label="申请时间" width="180"></el-table-column>
        <el-table-column prop="operationType" label="操作类型"></el-table-column>
        <el-table-column prop="reviewUserName" label="审核人"></el-table-column>
        <el-table-column prop="reviewContent" show-overflow-tooltip label="审核内容"></el-table-column>
        <el-table-column prop="reviewTime" label="审核时间" width="180"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showLog=false" size="small" type="primary" icon="el-icon-circle-check">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="checkItem.id?'修改活动':'创建商品折扣'" :visible.sync="showEdit" append-to-body width="40%">
      <el-form ref="ruleForm" :rules="rules" :model="checkItem" label-width="110px">
        <el-form-item label="商品名称" prop="productId">
          <p v-if="checkItem.id" style="margin:0;">{{checkItem.productName}}</p>
          <el-select v-else v-model="checkItem.productId" filterable clearable size="small" placeholder="选择商品名称">
            <el-option v-for="item in productList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="原价">{{originPrice||checkItem.originalPrice}}元</el-form-item>
        <el-form-item label="优惠价" prop="price">
          <el-input-number v-model="checkItem.price" size="small" :precision="2" :step="0.1" :min="0.01" :max="originPrice||checkItem.originalPrice"></el-input-number> 元
        </el-form-item>
        <el-form-item label="优惠标签">
          <!-- <p v-if="checkItem.id" style="margin:0;">{{checkItem.name}}</p> -->
          <el-input :maxlength="4" v-model="checkItem.name" size="small" placeholder="最多可输入4个中文字符"></el-input>
        </el-form-item>
        <el-form-item label="优惠状态">
          <el-radio v-model="checkItem.status" :label="1">生效</el-radio>
          <el-radio v-model="checkItem.status" :label="2">失效</el-radio>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="3" :maxlength="150" resize="none" v-model="checkItem.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="saveEdit('ruleForm')" v-auth="'memberDiscount_change'" size="small" type="primary" icon="el-icon-circle-check">保存</el-button>
        <el-button @click="showEdit=false" size="small" icon="el-icon-circle-close">取消</el-button>
      </div>
    </el-dialog>
  </basic-container>
</template>

<script>
import { discountList, submitDiscount, removeDiscount, commonProductList, reviewLog, applyDiscountExamine, updateDiscountExamine } from '@/api/member'
import { debounce, deepCopy } from '@/util/common'
import pagination from '@/util/mixins/pagination'
export default {
  mixins: [pagination],
  data () {
    return {
      productList: [], // 商品列表
      activeName: '1', // 选择tab
      productId: '', // 商品名称
      isIOS: '', // 销售渠道
      discountStatus: '', // 优惠状态
      checkStatus: '', // 审核状态
      checkItem: {}, // 查看项
      checkMark: '', // 审核意见
      showCheck: false, // 审核弹窗
      logData: [], // 日志列表
      showLog: false, // 操作日志弹窗
      rules: {
        productId: [{ required: true, message: '请选择商品名称' , trigger: 'change' }],
        price: [{ required: true, message: '请输入优惠价' , trigger: 'blur' }]
      },
      showEdit: false // 新增/修改弹窗
    }
  },
  computed: {
    originPrice () { // 展示原价
      let target = this.productList.filter(i => {
        return i.id === this.checkItem.productId
      })
      if (target.length) {
        return target[0].originalPrice
      } else {
        return ''
      }
    }
  },
  mounted () {
    commonProductList().then(res => {
      if (res.data.code === 200) {
        this.productList = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    this.getList()
  },
  methods: {
    // 打开审核
    openCheck (item) {
      this.checkMark = ''
      this.showCheck = true
      this.checkItem = deepCopy(item)
    },
    // 打开日志
    openLog: debounce(function (item) {
      reviewLog({
        bizCode: 21,
        bizRefrenceId: item.id
      }).then(res => {
        if (res.data.code === 200) {
          this.logData = res.data.data
          this.showLog = true
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 打开新增或编辑
    openEdit (item) {
      this.showEdit = true
      if (item.id) {
        this.checkItem = deepCopy(item)
      } else {
        this.checkItem = {
          productId: '',
          originalPrice: '',
          price: '',
          name: '',
          status: 1,
          remark: ''
        }
      }
    },
    // 获取列表
    getList () {
      this.listLoading = true
      let postData = {
        isUsed: this.activeName,
        productId: this.productId,
        isIOS: this.isIOS,
        status: this.discountStatus,
        current: this.pageNo,
        size: this.pageSize
      }
      if (this.activeName === '0') {
        postData.reviewStatus = this.checkStatus
      }
      let onSuccess = res => {
        this.listLoading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.records
          this.totalEl = res.data.data.total
        } else {
          this.$message.error(res.data.msg)
        }
      }
      discountList(postData).then(onSuccess).catch(() => { this.listLoading = false })
    },
    // 删除
    delDiscount (item) {
      this.$confirm('确定要删除选中的数据吗？', '提示', {
        type: 'warning'
      }).then(() => {
        removeDiscount({ ids: item.id }).then(res => {
          if (res.data.code === 200) {
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    // 保存新增或编辑
    saveEdit: debounce(function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submitDiscount(this.checkItem).then(res => {
            if (res.data.code === 200) {
              this.showEdit = false
              this.getList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          return false
        }
      })
    }, 300, false),
    // 提交审核
    submitCheck: debounce(function (item) {
      applyDiscountExamine({
        status: 1,
        bizRefrenceId: item.id
      }).then(res => {
        if (res.data.code === 200) {
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false),
    // 修改审核状态
    changeCheck: debounce(function (item, status) {
      let postData = {
        bizRefrenceId: item.id,
        status: status
      }
      if (status !== 4) {
        if (!this.checkMark && status === 3) {
          this.$message.warning('请输入审核意见')
          return
        }
        postData.content = this.checkMark
      }
      updateDiscountExamine(postData).then(res => {
        if (res.data.code === 200) {
          this.showCheck = false
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }, 300, false)
  }
}
</script>
